import actions from '@/store/modules/available-model/actions.js'
import mutations from '@/store/modules/available-model/mutations.js'
import getters from '@/store/modules/available-model/getters.js'
import {base_state} from '@/store/modules/base/state.js'

const state = {
  ...base_state,
  'api_module': 'available_model'
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}